import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import { updateCommittee, deleteCommittee } from '../../redux/actions/boardMemberActions';
import SpinnerV2 from '../Spinner/Spinner';
import CommitteeForm from './CommitteeForm';

const EditCommittee = (props) => {
  let { committeeId } = useParams();
  const dispatch = useDispatch()
  const boardMembers = useSelector(state => state.boardMembers)
  const [committee, setCommittee] = useState(undefined);
  const [isUpdating, setIsUpdating] = useState(false);
  const history = useHistory();
  
  const findCommittee = () => {
    const ix = boardMembers.committees.findIndex((c) => {
      if (c.id === Number(committeeId)) {
        return true;
      } else {
        return false;
      }
    })
    
    if (ix >= 0) {
      return {...boardMembers.committees[ix]}
    }
    return undefined;
  }

  useEffect(() => {
    if (committee === undefined) {
      const c = findCommittee()
      if (c !== undefined) {
        setCommittee(c)
      }
    }
    if (isUpdating && boardMembers.updating === false) {
      setIsUpdating(false);
      history.replace(`/documents`)
    }
  }, [boardMembers.updating])

  const onEditCommittee = (committee) => {
    setIsUpdating(true);
    dispatch(updateCommittee(committee));    
  }

  const deleteCommitteeConfirm = (committee) => {
    let areYouSure = window.confirm(`Are you sure you want to remove ${committee.name}?`);
    if (areYouSure) {
      setIsUpdating(true);
      dispatch(deleteCommittee(committee.id))
      return true;
    }
    return false;
  }

  // TODO: CHANGE this to report an error if committee === undefined
  if (boardMembers.updating || committee === undefined || isUpdating) {
    return <SpinnerV2 title="Updating committee..." />
  }

  return (
    <div>
      <CommitteeForm 
        title="Edit Board Member"
        edit={true} 
        committee={committee} 
        onSubmit={onEditCommittee}
        onCancel={() => {history.replace(`/documents`)}}
        onDelete={() => {deleteCommitteeConfirm(committee)}}
      />
    </div>
  );
}

export default EditCommittee;
